import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import {
  DEFAULT_WIDGETS,
  PERSONALIZATION_DEFAULT_CONFIG,
  WIDGETS,
} from '../../../shared/constants';
import { usePersonalization } from '../../../shared/hooks';
import { violationsTabActions } from '../data-store/violationsTabSlice';

const useWidgetInitialization = () => {
  const dispatch = useDispatch();
  const { getPersonlization } = usePersonalization();

  const defaultWidgets = useMemo(() => {
    const personalization = getPersonlization();

    return PERSONALIZATION_DEFAULT_CONFIG.saveWidget &&
      personalization &&
      personalization.widgets
      ? personalization.widgets
      : DEFAULT_WIDGETS;
  }, [getPersonlization]);

  useEffect(() => {
    const widgets = Object.values(WIDGETS);
    const modifiedWidgets = widgets
      .map((widget) => {
        const isDefaultWidget = defaultWidgets.includes(widget.value);

        return {
          ...widget,
          isChecked: isDefaultWidget,
        };
      })
      .sort((a, b) => {
        const indexA = defaultWidgets.indexOf(a.value);
        const indexB = defaultWidgets.indexOf(b.value);

        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }

        if (indexA !== -1) {
          return -1;
        }

        if (indexB !== -1) {
          return 1;
        }

        return 0;
      });

    dispatch(violationsTabActions.setWidgets(modifiedWidgets));
  }, [dispatch, defaultWidgets]);
};

// eslint-disable-next-line import/prefer-default-export
export { useWidgetInitialization };
